"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GdprCheckboxes = function GdprCheckboxes(_ref) {
  var message = _ref.message,
      inAppNotificationsAccepted = _ref.inAppNotificationsAccepted,
      smsNotificationsAccepted = _ref.smsNotificationsAccepted,
      emailNotificationsAccepted = _ref.emailNotificationsAccepted,
      onChange = _ref.onChange,
      hidePushNotifcationCheckbox = _ref.hidePushNotifcationCheckbox,
      hideSmsCheckbox = _ref.hideSmsCheckbox,
      hideEmailCheckbox = _ref.hideEmailCheckbox;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormRowText, {
      isNormal: true,
      children: message
    }), !hidePushNotifcationCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormRow, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormCheckbox, {
        isSmallerText: true,
        alignItems: "center",
        checked: inAppNotificationsAccepted,
        label: "Push Notification",
        onChange: onChange,
        name: "inAppNotificationsAccepted"
      })
    }), !hideSmsCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormRow, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormCheckbox, {
        isSmallerText: true,
        alignItems: "center",
        checked: smsNotificationsAccepted,
        label: "SMS",
        onChange: onChange,
        name: "smsNotificationsAccepted"
      })
    }), !hideEmailCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormRow, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.FormCheckbox, {
        isSmallerText: true,
        alignItems: "center",
        checked: emailNotificationsAccepted,
        label: "Email",
        onChange: onChange,
        name: "emailNotificationsAccepted"
      })
    })]
  });
};

var _default = GdprCheckboxes;
exports.default = _default;